<template>
  <!-- <div id='footer'>
    <span v-if="deployEnvirConfig==1">米粒助教：0512-68835501</span>
    <span v-if="deployEnvirConfig==2">苏州阿芬奇网络科技有限公司提供技术支持服务</span>
  </div> -->
</template>

<script>
export default {
  data(){
    return {
      deployEnvirConfig: this.staticConfig.deployEnvirConfig
    }
  }
}
</script>

<style lang="scss" scoped>
  #footer {
    color: #a3a5a9;
    text-align: center;
    font-size: 12px;
    padding-bottom: 10px;
  }
  .myfoot[data-v-04eb4790] {
    position: fixed;
    width: 180px;
    left: 0;
    bottom: 0;
    z-index: 99;
    padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue